export default {
  __name: 'AppCopyright',
  setup(__props) {
    const year = new Date().getFullYear();
    return {
      __sfc: true,
      year
    };
  }
};